import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@chakra-ui/icons";
import { Flex, IconButton, Text, Tooltip } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Page } from "../models/Paged";

type Props = {
  pagination: Page;
  goToPage: (page: number) => void;
};

export default function Pagination({ pagination, goToPage }: Props) {
  const { t } = useTranslation();

  return (
    <Flex
      justifyContent="space-between"
      p={4}
      alignItems="center"
      position="sticky"
      left={0}
    >
      <Flex>
        <Tooltip label={t("common.labels.first_page")}>
          <IconButton
            aria-label={t("common.labels.first_page")}
            onClick={() => goToPage(0)}
            isDisabled={pagination.number === 0}
            icon={<ArrowLeftIcon h={3} w={3} />}
            mr={4}
          />
        </Tooltip>
        <Tooltip label={t("common.labels.previous_page")}>
          <IconButton
            aria-label={t("common.labels.previous_page")}
            onClick={() => goToPage(pagination.number - 1)}
            isDisabled={pagination.number - 1 < 0}
            icon={<ChevronLeftIcon h={6} w={6} />}
          />
        </Tooltip>
      </Flex>

      <Flex alignItems="center">
        <Text flexShrink="0" mr={8}>
          {t("common.labels.page")}{" "}
          <Text fontWeight="bold" as="span">
            {pagination.number + 1}
          </Text>{" "}
          {t("common.labels.of")}{" "}
          <Text fontWeight="bold" as="span">
            {pagination.totalPages}
          </Text>
        </Text>
      </Flex>

      <Flex>
        <Tooltip label={t("common.labels.next_page")}>
          <IconButton
            aria-label={t("common.labels.next_page")}
            onClick={() => goToPage(pagination.number + 1)}
            isDisabled={pagination.number + 1 > pagination.totalPages - 1}
            icon={<ChevronRightIcon h={6} w={6} />}
          />
        </Tooltip>
        <Tooltip label={t("common.labels.last_page")}>
          <IconButton
            aria-label={t("common.labels.last_page")}
            onClick={() => goToPage(pagination.totalPages)}
            isDisabled={pagination.number === pagination.totalPages - 1}
            icon={<ArrowRightIcon h={3} w={3} />}
            ml={4}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
}
